export default __webpack_public_path__ + "static/StackOfLovelyStreamrTokens@2x-1a2e25ccbdd24ae6bde30055bad92ae2.png";